<template>
    <div class="main" v-if="!loading">
        
        <el-form @submit.native.prevent="onSubmit" style="min-height: 270px;" :model="dados" ref="dados" label-position="top">
            
            <div>
                <i class="u-mb-10" style="display: block">
                    Para resolver o conflito, você deverá alterar uma das frequência (Frequência 1 ou Frequência 2). 
                    Selecione uma nova data, turma ou horário para uma das frequências.
                </i>
                <c-panel title="DADOS GERAIS">
                    <el-row :gutter="10" class="">
                        <el-col :xs="24" :sm="12" :md="12">
                            <dl>
                                <dt>DATA:</dt>
                                <dd>
                                    {{ $moment(dados.data).format('DD/MM/YYYY') }}
                                </dd>
                            </dl>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <dl>
                                <dt>TURMA</dt>
                                <dd>
                                    {{ dados.turma.nome }}
                                </dd>
                            </dl>
                        </el-col>                    
                    </el-row>
                    <el-row :gutter="10" class="">
                        <el-col :xs="24" :sm="24" :md="24">
                            <dl>
                                <dt>HORÁRIO</dt>
                                <dd>
                                    {{ dados.horario }}º HORÁRIO
                                </dd>
                            </dl>
                        </el-col>                    
                    </el-row>
                </c-panel>

                
                <el-row :gutter="10" class="">
                    <el-col :xs="24" :sm="12" :md="12">
                        <c-panel title="FREQUÊNCIA 1">
                            <el-row :gutter="10" class="">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <dl>
                                        <dt>DISCIPLINA:</dt>
                                        <dd>
                                            {{ dados.chamada_one.disciplina.nome }}
                                        </dd>
                                    </dl>
                                </el-col>                  
                            </el-row>
                            <el-row :gutter="10" class="">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <dl>
                                        <dt>USUÁRIO:</dt>
                                        <dd style="text-transform: uppercase;">
                                            {{ dados.chamada_one.user.nome }}
                                        </dd>
                                    </dl>
                                </el-col>                  
                            </el-row>
                            <el-row :gutter="10" class="">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <dl>
                                        <dt>DATA:</dt>
                                        <dd class="ws-100">
                                            <el-select v-model="dados.chamada_one.data">
                                                <el-option v-for="(item, i) in dados.datas" :label="formatDate(item)" :value="item" :key="i"> </el-option>
                                            </el-select>
                                        </dd>
                                    </dl>                                        
                                </el-col>                  
                            </el-row>
                            <el-row :gutter="10" class="">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <dl>
                                        <dt>HORÁRIO:</dt>
                                        <dd class="ws-100">
                                            <el-select v-model="dados.chamada_one.horario">
                                                <el-option v-for="(item, i) in horarios" :label="item.text" :value="item.id" :key="i"> </el-option>
                                            </el-select>
                                        </dd>
                                    </dl>                                        
                                </el-col>                  
                            </el-row>

                            <el-row v-if="$store.state.user.id == 238" :gutter="10" class="">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <el-form-item class="u-text-right">
                                        <el-button @click.prevent="deleteConflitoOne()" id="deleteConflitoOne" type="danger">EXCLUIR</el-button>
                                    </el-form-item>                                      
                                </el-col>                  
                            </el-row>
                        </c-panel>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12">
                        <c-panel title="FREQUÊNCIA 2">
                            <el-row :gutter="10" class="">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <dl>
                                        <dt>DISCIPLINA:</dt>
                                        <dd>
                                            {{ dados.chamada_tow.disciplina.nome }}
                                        </dd>
                                    </dl>
                                </el-col>                  
                            </el-row>
                            <el-row :gutter="10" class="">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <dl>
                                        <dt>USUÁRIO:</dt>
                                        <dd style="text-transform: uppercase;">
                                            {{ dados.chamada_tow.user.nome }}
                                        </dd>
                                    </dl>
                                </el-col>                  
                            </el-row>
                            <el-row :gutter="10" class="">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <dl>
                                        <dt>DATA:</dt>
                                        <dd class="ws-100">
                                            <el-select v-model="dados.chamada_tow.data">
                                                <el-option v-for="(item, i) in dados.datas" :label="formatDate(item)" :value="item" :key="i"> </el-option>
                                            </el-select>
                                        </dd>
                                    </dl>                                        
                                </el-col>                  
                            </el-row>
                            <el-row :gutter="10" class="">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <dl>
                                        <dt>HORÁRIO:</dt>
                                        <dd class="ws-100">
                                            <el-select v-model="dados.chamada_tow.horario">
                                                <el-option v-for="(item, i) in horarios" :label="item.text" :value="item.id" :key="i"> </el-option>
                                            </el-select>
                                        </dd>
                                    </dl>                                        
                                </el-col>                  
                            </el-row>
                            
                            <el-row v-if="$store.state.user.id == 238" :gutter="10" class="">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <el-form-item class="u-text-right">
                                        <el-button @click="deleteConflitoTwo()" id="deleteConflitoTwo" type="danger">EXCLUIR</el-button>
                                    </el-form-item>                                      
                                </el-col>                  
                            </el-row>
                        </c-panel>
                    </el-col>
                </el-row>        
                
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right">
                            <el-button type="primary" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>
    </div>
</template>
<script>

export default {
    data () {
        return {
            horarios: [],
            dados: {},
            conflito_id: this.$route.params.id,
            loading: true
        }
    },
    mounted () {
        this.initFormGerenciarConflitos();
    },
    methods:{
        async initFormGerenciarConflitos(){

            this.loading = true;

            let response = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/frequencia/getConflitoById/${this.$route.params.id}`, this.$store.getters.getHeaderAuth);
            
            if(typeof response.data.error !== 'undefined'){

                this.loading = false;
                window.eventBus.$emit('alert', {msg: response.data.error, type: 'warning'});

            }else{

                this.dados = JSON.parse(JSON.stringify(response.data));

                for(let i = 1; i <= this.dados.turma.qtd_horarios; i++) {
                    this.horarios.push({ id: i, text: `${i}º horário`});
                }

                await this.changeForm();
                        
                this.loading = false;
            } 
        },        
        formatDate(data){

            return this.$moment(data).format('DD/MM/YYYY');
        },
        async onSubmit(){

            this.$refs.dados.validate( async (valid) => { if(valid){

                if(this.dados.chamada_one.data == this.dados.chamada_tow.data && this.dados.chamada_one.horario == this.dados.chamada_tow.horario) {
                    window.eventBus.$emit('alert', {msg: 'É necessário resolver o conflito para continuar.', type: 'warning'});
                    return;
                }

                let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/frequencia/resolveConflito/${this.$route.params.id}`, this.dados, this.$store.getters.getHeaderAuth);

                if(typeof response.data.error !== 'undefined'){

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: response.data.error, type: 'warning'});

                }else{

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.$router.push(`/admin/diario/conflitos-frequencia`);  
                }

            }else{ window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'}); }});
        },
        async changeForm(){           

            if(!this.dados.data || !this.dados.turma.id) {
                return;
            }

            let paylod = {
                data: this.dados.data,
                turma_id: this.dados.turma.id
            }           
            

            let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/getAlunosByFrequencia`, paylod, this.$store.getters.getHeaderAuth);   

            this.dados.alunos = response.data    

        }, 
        async deleteConflitoOne(){      
            
             let payload = {
                    chamada_tow: this.dados['chamada_tow'], 
                    conflito_id: this.dados['conflito_id'], 
                    turma_id: this.dados['turma']['id'],
                    alunos: this.dados['alunos'],
                    horario: this.dados['horario'],
                    data: this.dados['data'],
                }

            
                
            this.$msgbox.confirm('Tem certeza que deseja excluir esta frequência?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then( async () => {  
               

                    window.eventBus.$emit('loading', true);  

                    let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/frequencia/deleteConflitoOne`, payload, this.$store.getters.getHeaderAuth);

                    if(typeof response.data.error !== 'undefined'){

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: response.data.error, type: 'warning'});

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.dados = {                           
                            data: '',
                            turma: '',
                            horario: '',
                            alunos: [],
                           
                        }; 
                        this.$router.push(`/admin/diario/conflitos-frequencia`); 
                    }

            }).catch((e)=>{console.log(e);});
        },    
        async deleteConflitoTwo(){

             let payload = {                    
                    conflito_id: this.dados['conflito_id'], 
                    turma_id: this.dados['turma']['id'],                    
                    data: this.dados['data'],
                    horario: this.dados['horario'],
                }
            

            this.$msgbox.confirm('Tem certeza que deseja excluir esta frequência?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then( async () => {
                               
                window.eventBus.$emit('loading', true);
                    
                let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/frequencia/deleteConflitoTwo`, payload, this.$store.getters.getHeaderAuth);

                if(typeof response.data.error !== 'undefined'){

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: response.data.error, type: 'warning'});

                }else{

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.$router.push(`/admin/diario/conflitos-frequencia`);  
                }

            }).catch((e)=>{console.log(e);});
        }
    }    
}
</script>
<style>

    .ws-100{
        width: 100%;
    }

    .ws-100 .el-input__inner {
        border-bottom: none !important;
        background-color: #efefef !important;
        padding: 0 0 0 13px !important;
    }

</style>
